import { Link } from 'react-router-dom';
import { trendingVideos } from '@/mocks/homeData';

export default function TrendingSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受欢迎的影视内容，大家都在看</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {trendingVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={video.imageUrl}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={`${video.title} - 糖心视频免费在线观看`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="bg-background-950/70 text-background-50 text-xs px-2 py-0.5 rounded-md backdrop-blur-sm">
                    {video.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </div>
                </div>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <div className="flex items-center gap-2 mt-1.5">
                <span className="text-xs text-foreground-500">{video.categoryName}</span>
                <span className="text-foreground-300 text-xs">·</span>
                <span className="text-xs text-foreground-500">{video.views}次播放</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}